import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuthStore } from '../stores/authStore';

const { FiMail, FiLock, FiEye, FiEyeOff } = FiIcons;

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [formData, setFormData] = useState({
    email: 'test@test.com',
    password: '123'
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = login(formData.email, formData.password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setIsLoading(false);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white py-12 px-4 sm:px-6 lg:px-8">
      <motion.div
        className="max-w-md w-full space-y-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div>
          <div className="flex justify-center">
            <div className="flex items-center space-x-2" style={{ color: '#2b6777' }}>
              <img 
                src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
                alt="Logo" 
                className="w-12 h-12"
              />
              <span className="text-2xl font-bold font-rubik">Interaktive Geschichten</span>
            </div>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold font-rubik" style={{ color: '#2b6777' }}>
            In Ihr Konto einloggen
          </h2>
          <p className="mt-2 text-center text-sm font-rubik" style={{ color: '#2b6777' }}>
            Verwenden Sie die Test-Zugangsdaten: test@test.com / 123
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <motion.div
              className="border px-4 py-3 rounded"
              style={{ 
                backgroundColor: '#fee2e2', 
                borderColor: '#fecaca', 
                color: '#991b1b' 
              }}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              {error}
            </motion.div>
          )}

          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium font-rubik" style={{ color: '#2b6777' }}>
                E-Mail-Adresse
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SafeIcon icon={FiMail} className="h-5 w-5" style={{ color: '#9ca3af' }} />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:border-gray-400 font-rubik"
                  style={{ color: '#2b6777' }}
                  placeholder="Geben Sie Ihre E-Mail ein"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium font-rubik" style={{ color: '#2b6777' }}>
                Passwort
              </label>
              <div className="mt-1 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SafeIcon icon={FiLock} className="h-5 w-5" style={{ color: '#9ca3af' }} />
                </div>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:border-gray-400 font-rubik"
                  style={{ color: '#2b6777' }}
                  placeholder="Geben Sie Ihr Passwort ein"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <SafeIcon 
                    icon={showPassword ? FiEyeOff : FiEye} 
                    className="h-5 w-5 hover:text-gray-600" 
                    style={{ color: '#9ca3af' }}
                  />
                </button>
              </div>
            </div>
          </div>

          <div>
            <motion.button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed font-rubik"
              style={{ backgroundColor: '#c8d8e4' }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isLoading ? 'Anmelden...' : 'Anmelden'}
            </motion.button>
          </div>

          <div className="text-center">
            <Link to="/" className="font-medium font-rubik" style={{ color: '#2b6777' }}>
              ← Zurück zur Startseite
            </Link>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default LoginPage;